<template>
  <v-container fluid class="mx-0 px-0">
    <h3 class="mt-3 mb-0">{{ $t('Prašymo dokumento informacija') }}</h3>
    <v-card
      class="ntr-card-gray pt-0 pb-2 px-2 mt-3"
      flat
      v-if="showRasytinisSuktikimas"
    >
      <v-row dense no-gutters>
        <v-col cols="12" md="12" align-self="center">
          <el-checkbox
            :label="
              $t(
                'Rašytinis turto savininko (-ų) sutikimas kartu su sutartimi nepateikiamas, nes sutikimas subnuomai išreikštas nuomos sutartyje'
              )
            "
            :tooltip="
              `${ntrTooltipPrefix} Registravimas. Rašytinis turto savininko sutikimas`
            "
            class="mt-3"
            :readonly="isReadonly"
            validate-key="rasytinis_sutikimas"
            v-model="registravimas.pra_sutikimas"
            @click.native="saveData(true)"
          />
        </v-col>
      </v-row>
    </v-card>
    <prasymas-upload
      :readonly="isReadonly || !bylosSegamos"
      @updated="updatedUpload"
    />

    <h3 class="mt-3 mb-0">{{ $t('Paslaugos užsakymo informacija') }}</h3>

    <v-card class="ntr-card-gray pt-0 pb-2 px-2 mt-3" flat>
      <v-row dense no-gutters v-if="showPagrindas">
        <v-col class="bold-label pt-4" cols="12" md="4" align-self="center">
          <div style="position: relative;" class="pr-4">
            {{ $t('Juridinio fakto išregistravimo pagrindas') }}
            <el-tooltip
              inline
              :tooltip="
                `${ntrTooltipPrefix} Registravimas. Juridinio fakto išregistravimo pagrindas`
              "
            />
          </div>
        </v-col>
        <v-col cols="12" md="8">
          <el-autocomplete
            :items="pagrindas"
            itemvalue="value"
            itemtext="text"
            validate-key="Juridinio fakto išregistravimo pagrindas"
            hide-details="auto"
            :readonly="true"
            v-model="registravimas.pra_pagrindas_kla_id"
            @change="saveData()"
          />
        </v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col class="bold-label pt-4" cols="12" md="4" align-self="center">
          <div style="position: relative;">
            {{ skubaTitle }}<el-need v-if="!isReadonly" />
            <el-tooltip
              inline
              :tooltip="
                `${ntrTooltipPrefix} Registravimas. ${skubaTitleTooltip}`
              "
            />
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <el-autocomplete
            :items="skubos"
            itemvalue="value"
            itemtext="text"
            validate-key="Juridinio fakto įregistravimo skuba"
            :readonly="isReadonly || isGrazintas"
            hide-details="auto"
            v-model="registravimas.pra_skuba"
            @change="saveData()"
          />
        </v-col>
      </v-row>
      <v-row dense no-gutters class="mt-3">
        <v-col class="bold-label mt-2" cols="12" md="4" align-self="start">
          {{ $t('Užsakyti NTR išrašą') }}
          <el-tooltip
            inline
            :tooltip="`${ntrTooltipPrefix} Registravimas. Užsakyti NTR išrašą`"
          />
        </v-col>
        <v-col cols="12" md="8">
          <el-checkbox
            v-if="showCheckAll"
            class="check-all align-center justify-center mt-1"
            :validate-key="`check-all`"
            v-model="headerCheck"
            @click.native.stop="checkAll()"
            :label="$t('Pažymėti visus')"
          />

          <v-data-table
            class="prasymas-miniTable"
            :headers="filteredTurtasHeaders"
            :items="turtasList"
            :loading="loading"
            :footer-props="{
              showFirstLastPage: true,
              showCurrentPage: true,
              itemsPerPageText: this.$t('Rodyti po:'),
              itemsPerPageAllText: this.$t('visi'),
              itemsPerPageOptions: itemsPerPageOptions,
            }"
            :hide-default-footer="hideTurtasFooter"
            hide-default-header
            :items-per-page="pageSize"
            single-expand
            item-key="reg_id"
          >
            <template #[`item.actions`]="{ item }">
              <el-checkbox
                class="mb-2"
                :validate-key="`check-${item.reg_id}`"
                v-model="pasirinktiTurtai"
                :checkValue="item.reg_id"
                :key="item.reg_id"
                :readonly="isReadonly || isGrazintas"
                :disabled="isReadonly || isGrazintas"
                @click.native.stop="checkItem(item)"
              />
            </template>
            <template #[`item.tur_registras`]="{ item }">
              <div class="turtas-text">{{ item.tur_registras }}</div>
            </template>
            <template #[`item.tur_ntr_adresas`]="{ item }">
              <div class="turtas-text">{{ item.tur_ntr_adresas }}</div>
            </template>
            <template #[`item.bylos`]="{ item }">
              <div class="nowrap">
                <el-byla
                  v-for="byla in item.bylos"
                  :key="byla.byl_id"
                  :byla="byla"
                  :withName="true"
                  color="primary"
                />
              </div>
            </template>
            <template slot="loading">
              {{ $t('Kraunasi...') }}
            </template>
            <template slot="no-results">
              <div></div>
            </template>
            <template slot="no-data">
              <div></div>
            </template>
            <template #[`footer.page-text`]="props">
              {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
              {{ $t('iš') }}
              {{ props.itemsLength }}
            </template>
          </v-data-table>
        </v-col>
        <v-col cols="12" md="12" v-if="showIsrasasInfo">
          <span
            >{{
              $t('Suformuoti išrašai saugomi {saugojimoLaikas} k.d.', {
                saugojimoLaikas,
              })
            }}
          </span>
        </v-col>
      </v-row>
    </v-card>

    <prasymas-paslaugos :key="`paslaugos-${this.paslaugosRefresh}`" />

    <prasymas-istorija />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import PrasymasPaslaugos from './PrasymasPaslaugos'
import PrasymasUpload from './PrasymasUpload'
import PrasymasIstorija from '../prasymas/PrasymasIstorija'
import userRole from '@/mixins/userRole'
import busena from '@/mixins/busenaNtr'
import tooltipNtr from '@/mixins/tooltipNtr'
import checkErrors from '@/mixins/checkErrors'

export default {
  name: 'PrasymasRegistravimas',
  components: { PrasymasPaslaugos, PrasymasUpload, PrasymasIstorija },
  props: {
    readonly: { type: Boolean, default: false },
  },
  mixins: [userRole, busena, tooltipNtr, checkErrors],
  data() {
    return {
      pageloading: true,
      loading: true,
      registravimas: {},
      turtai: [],
      pasirinktiTurtai: [],
      headerCheck: false,
      skubos: [],
      pagrindas: [],
      bylosSegamos: false,
      saugojimoLaikas: '',
      uploadProgress: 0,
      uploadedFiles: [],
      paslaugosRefresh: 0,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
    }
  },
  computed: {
    ...mapGetters(['prasymasID', 'prasymasOwner']),
    showPagrindas() {
      return this.isPrasymasSeima && this.isPrasymasIsregistravimas
    },
    isReadonly() {
      return this.readonly
    },
    showAddRinkmenos() {
      return !this.readonly
    },
    skubaTitle() {
      if (this.isPrasymasSeima && this.isPrasymasPerkelimas) {
        return this.$t('Juridinio fakto perkėlimo skuba')
      }
      if (this.isPrasymasIsregistravimas || this.isPrasymasNutraukimas) {
        return this.$t('Juridinio fakto išregistravimo skuba')
      }
      if (this.isPrasymasPakeitimas) {
        return this.$t('Juridinio fakto pakeitimo skuba')
      }
      return this.$t('Juridinio fakto įregistravimo skuba')
    },
    skubaTitleTooltip() {
      if (this.isPrasymasSeima && this.isPrasymasPerkelimas) {
        return this.$t('Juridinio fakto pakeitimo skuba')
      }
      if (this.isPrasymasIsregistravimas || this.isPrasymasNutraukimas) {
        return 'Juridinio fakto išregistravimo skuba'
      }
      if (this.isPrasymasPakeitimas) {
        return 'Juridinio fakto pakeitimo skuba'
      }
      return 'Juridinio fakto įregistravimo skuba'
    },

    turtasHeaders() {
      return [
        {
          text: this.$t('Pasirinkti'),
          align: 'start',
          sortable: false,
          value: 'actions',
          cellClass: 'turtas-pasirinkti',
        },
        {
          text: this.$t('Registras'),
          align: 'start',
          value: 'tur_registras',
          cellClass: 'turtas-registras',
        },
        {
          text: this.$t('Adresas'),
          align: 'start',
          value: 'tur_ntr_adresas',
          cellClass: 'turtas-adresas',
        },
        {
          text: this.$t('Dokumentai'),
          align: 'start',
          value: 'bylos',
          cellClass: 'turtas-bylos',
          hide: !this.showIsrasasBylos,
        },
      ]
    },
    filteredTurtasHeaders() {
      return this.turtasHeaders.filter(item => {
        return !item.hide
      })
    },
    turtasList() {
      return this.turtai.map(turtas => {
        turtas.bylos = turtas.bylos.map(byla => {
          return {
            ...byla,
            byl_rusis: byla.byl_tipas,
            byl_tipas: 'ntr_israsas',
            icon_title: this.$t('NTR išrašas'),
            byl_url: `ntrpaslaugos/byla/${byla.byl_id}/${byla.byl_hash}/content`,
          }
        })
        turtas.canDownload = true

        return turtas
      })
    },
    hideTurtasFooter() {
      return this.turtasList.length <= 10
    },
    showCheckAll() {
      return !this.isReadonly && !this.isGrazintas && this.turtai.length > 1
    },
    showIsrasasBylos() {
      return this.isIregistruotas && this.prasymasOwner
    },
    showIsrasasInfo() {
      return !this.pageloading && this.prasymasOwner
    },
    showRasytinisSuktikimas() {
      return this.isPrasymasSubnuoma && this.isPrasymasIregistravimas
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true
      this.$axios
        .get(`ntrpaslaugos/prasymas/${this.prasymasID}/registravimas`)
        .then(res => {
          this.registravimas = res.data.registravimas
          this.turtai = res.data.turtai
          this.pasirinktiTurtai = this.registravimas.pra_israsai
          this.skubos = res.data.skubos
          this.pagrindas = res.data.pagrindas
          this.bylosSegamos = res.data.bylos_segamos
          this.saugojimoLaikas = res.data.saugojimo_laikas
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    saveData(reload = false) {
      if (this.isReadonly) {
        return
      }
      const data = {
        pra_id: this.prasymasID,
        pra_skuba: this.registravimas.pra_skuba,
        pra_israsai: this.pasirinktiTurtai,
        pra_pagrindas_kla_id: this.registravimas.pra_pagrindas_kla_id,
        pra_sutikimas: this.registravimas.pra_sutikimas,
      }

      this.$axios
        .post(`ntrpaslaugos/prasymas/${this.prasymasID}/registravimas`, data)
        .then(res => {
          this.paslaugosRefresh++
          this.updateErrors()
          if (reload) {
            this.getData()
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    updatedUpload() {
      this.updateErrors()
    },
    checkAll() {
      this.pasirinktiTurtai = []
      if (this.headerCheck) {
        this.turtai.forEach(item => {
          this.pasirinktiTurtai.push(item.reg_id)
        })
      }
      this.saveData()
    },
    checkItem(turtas) {
      this.saveData()
    },
  },
}
</script>
<style lang="scss">
.prasymas-miniTable table tbody tr td {
  padding: 0px 5px !important;
  height: auto !important;
}
.check-all {
  margin-left: 5px;
}
.turtas-text {
  margin-top: 2px;
}
.turtas-pasirinkti {
  width: 40px;
}
.turtas-registras {
  width: 80px;
}
.turtas-bylos {
  width: 50px;
}
</style>
